import { defineStore } from 'pinia';
import { ref } from 'vue';

import type { UserStatus } from '@/types/user';

export type RealtimeUserStatus = {
  status: UserStatus;
  lastStatusChangedAt?: string;
};

export type RealtimeUserStatusChange = {
  userId: string;
  previous?: RealtimeUserStatus;
  current: RealtimeUserStatus;
};

export const useRealtimeUserStatusStore = defineStore('realtimeUserStatus', () => {
  const byUserId = ref<Record<string, RealtimeUserStatus>>({});
  const tick = ref(0);
  const lastChange = ref<RealtimeUserStatusChange | null>(null);
  const activeUsers = ref(0);
  const activeUsersRefetchKey = ref(0);

  function upsert(userId: string, status: RealtimeUserStatus): RealtimeUserStatus | undefined {
    const key = String(userId);
    const previous = byUserId.value[key];
    byUserId.value = {
      ...byUserId.value,
      [key]: status,
    };
    lastChange.value = { userId: key, previous, current: status };
    tick.value++;
    return previous;
  }

  function changeActiveUsersRefetchKey(): void {
    ++activeUsersRefetchKey.value;
  }

  function setActiveUsersNumber(value: number): void {
    activeUsers.value = value;
  }

  return {
    byUserId,
    tick,
    lastChange,
    activeUsers,
    activeUsersRefetchKey,
    upsert,
    changeActiveUsersRefetchKey,
    setActiveUsersNumber,
  };
});
